import React, { useEffect, useState } from "react";

// tremor
import { DateRangePicker } from "@tremor/react";

// bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/esm/Button";

// styling
import { Spacing } from "_styles";

import { CustomSpinner } from "_atoms";

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  getAllTaskListWithFilter,
  selectAllTaskWithFilterStatus,
} from "_redux/slices/timeline/employees";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";

const TimelineAnalyticsFilter = ({ closeFilterModal }) => {
  //redux
  const dispatch = useDispatch();
  const dbUser = useSelector(selectFirebaseInfo); // logged in user
  const allTaskWithFilterStatus = useSelector(selectAllTaskWithFilterStatus); // all tasks with filter status

  //states
  const [date, setDate] = useState([new Date(), new Date()]);
  const [isPlanned, setIsPlanned] = useState("bySystem");
  const [isTransit, setIsTransit] = useState(false);
  const [allTasks, setAllTasks] = useState(false);

  const handleExportReport = () => {
    if (dbUser.details.authority) {
      const iata = dbUser.details.authority;
      let params = {
        iata,
        startDate: date[0],
        endDate: date[1],
        isPlanned,
        isTransit,
        allTasks,
      };
      dispatch(getAllTaskListWithFilter(params));
    }
  };

  useEffect(() => {

    if (allTaskWithFilterStatus === "succeeded") closeFilterModal()

  }, [allTaskWithFilterStatus])

  return (
    <div >
      <div>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "100%" }}>
            <p>Date:</p>
            <DateRangePicker
              onValueChange={(value) => setDate(value)}
              value={date}
              enableDropdown={true}
              maxWidth="max-w-lg"
              dropdownPlaceholder={"Today"}
            />
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          {/*filter by type if created from portal or employee APP */}
          <div>
            <p>Assignment type:</p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Check
                type="radio"
                label="By system"
                value="bySystem"
                checked={isPlanned === "bySystem"}
                onChange={(e) => setIsPlanned(e.target.value)}
              />
              <Form.Check
                type="radio"
                label="By user"
                value="byUser"
                checked={isPlanned === "byUser"}
                onChange={(e) => setIsPlanned(e.target.value)}
                style={{ marginLeft: Spacing.SCALE_32 }}
              />
            </div>
          </div>
          {/*filter if transit booking or not*/}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
            <p>Transit bookings:</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Form.Check
                onClick={() => setIsTransit(!isTransit)}
                type="switch"
                defaultChecked={isTransit}
              />
            </div>
          </div>
          {/* All tasks by the date range*/}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
            <p>All tasks:</p>
            <div style={{ display: "flex", justifyContent: "center" }} >
              <Form.Check
                onClick={() => setAllTasks(!allTasks)}
                type="switch"
                defaultChecked={allTasks}
              />
            </div>
          </div>
        </div>
      </div>
      {/* buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="primary" onClick={handleExportReport}>
          {allTaskWithFilterStatus == 'loading' ? <CustomSpinner /> : 'Export Report'}
        </Button>
      </div>
    </div>
  );
};

export default TimelineAnalyticsFilter;
